<script lang="ts">
    import Siema from 'siema'
    import {onMount, createEventDispatcher, onDestroy} from 'svelte'

    export let perPage = 1 // nb slide par page
    export let loop = true // make carousel on loop
    export let autoplay = 0 // in ms, set the time between each slide before change
    export let duration = 500 // translation duration
    export let easing = 'ease-out'
    export let startIndex = 0 // index's slide starter
    export let draggable = true // enable/disable draggable carousel
    export let multipleDrag = false
    export let dots = true // enable/disable dots
    export let controls = true // enable/disable arrow control
    export let threshold = 20
    export let rtl = false // enable/disable direction transition of slides
    export let pauseOnMouseOver = true // enable/disable to pause autoplay on mouse over the carousel
    let currentIndex = startIndex;
    let onPause = false;

    let siema
    let controller
    let timer
    let previousIndex = 0
    const dispatch = createEventDispatcher()

    $: pips = controller ? controller.innerElements : []
    $: currentPerPage = controller ? controller.perPage : perPage
    $: totalDots = controller ? Math.ceil(controller.innerElements.length / currentPerPage) : []


    onMount(() => {
        controller = new Siema({
            selector: siema,
            perPage: typeof perPage === 'object' ? perPage : Number(perPage),
            loop,
            duration,
            easing,
            startIndex,
            draggable,
            multipleDrag,
            threshold,
            rtl,
            onChange: handleChange
        });

        if (autoplay) {
            timer = setInterval(right, autoplay);
        }
        onMounted();
        return () => {
            autoplay && clearInterval(timer);
            controller.destroy();
        }
    })

    onDestroy(() => {
        autoplay && clearInterval(timer);
        controller.destroy();
        onDestroyed();
    })

    export function onMounted() {
        return new Promise((resolve) => {
            resolve();
        });
    }

    export function onDestroyed() {
        return new Promise((resolve) => {
            resolve();
        });
    }

    export function isDotActive(currentIndex, dotIndex) {
        if (currentIndex < 0) currentIndex = pips.length + currentIndex;
        return currentIndex >= dotIndex * currentPerPage && currentIndex < (dotIndex * currentPerPage) + currentPerPage
    }

    export function left() {
        controller.prev()
        onLeft()
    }

    export function right() {
        controller.next()
        onRight()
    }

    export function go(index) {
        controller.goTo(index)
    }

    export function pause() {
        clearInterval(timer);
    }

    export function resume() {
        if (autoplay) {
            timer = setInterval(right, autoplay);
        }
    }

    function onLeft() {
        dispatch('on-left', {})
    }

    function onRight() {
        dispatch('on-right', {})
    }

    function handleOnMouseOver() {
        if (pauseOnMouseOver) {
            if (onPause) {
                resume()
                onPause = false;
            } else {
                pause()
                onPause = true;
            }
        }
    }

    function handleChange(event) {
        currentIndex = controller.currentSlide
        dispatch('on-change', {
            currentSlide: controller.currentSlide,
            slideCount: controller.innerElements.length
        })
    }

    function resetInterval(node, condition) {

        function handleReset(event) {
            if (!onPause) {
                pause();
                resume();
            }
        }

        if (condition) {
            node.addEventListener('click', handleReset);
        }

        return {
            destroy() {
                node.removeEventListener('click', handleReset);
            }
        }

    }
</script>

<div class="carousel">
    <div id="slides" class="slides" bind:this={siema} on:mouseenter="{handleOnMouseOver}" on:mouseleave="{handleOnMouseOver}">
        <slot></slot>
    </div>
    {#if controls && totalDots > 1}
        <button class="left" on:click={left} use:resetInterval={autoplay} aria-label="left">
            <slot name="left-control"></slot>
        </button>
        <button class="right" on:click={right} use:resetInterval={autoplay} aria-label="right">
            <slot name="right-control"></slot>
        </button>
    {/if}
    {#if dots}
        <ul>
            {#each {length: totalDots} as _, i}
                <li on:click={() => go(i*currentPerPage)} class={isDotActive(currentIndex, i) ? "active" : ""}></li>
            {/each}
        </ul>
    {/if}
</div>

<style lang="scss">
  @import "./styles/variables.scss";

  .carousel {
    position: relative;
    width: 100%;
    height: 100%;
    justify-content: center;
    align-items: center;

    .slides{
      width: 100%;
      text-align: center;
    }

    button {
      position: absolute;
      width: 100px;
      height: calc(100% - 22px);
      top: 0;
      z-index: 19;
      border: none;
      background-color: transparent;
      cursor: pointer;

      &:focus {
        outline: none;
      }

      &.left {
        left: 0;
      }

      &.right {
        right: 0;
      }
    }

    ul {
      list-style-type: none;
      position: relative;
      display: flex;
      justify-content: center;
      width: 100%;
      margin-top: 10px;
      padding: 0;
      li {
        margin: 6px;
        border-radius: 100%;
        background-color: $dark-black;
        height: 12px;
        width: 12px;
        opacity: 0.3;

        &:hover {
          opacity: 0.7;
        }

        &.active {
          opacity: 1;
        }
      }
    }
  }


</style>


